// eslint-disable-next-line import/prefer-default-export
export const twemojiParameters = {
  base: '/',
  folder: 'svg',
  ext: '.svg'
}

export const decodeEmoji = (codeString = '') => {
  if (!codeString) return ''

  // Split the input string by spaces to handle multiple emoji codes
  return codeString
    .split(' ')
    .map(code => {
      try {
        const hexCode = code.replace('U+', '')
        const codePoint = parseInt(hexCode, 16)

        if (isNaN(codePoint) || codePoint < 0) {
          console.error(`Invalid emoji code: ${code}`)
          return ''
        }

        return String.fromCodePoint(codePoint)
      } catch (error) {
        console.error(`Failed to decode emoji code "${code}":`, error)
        return ''
      }
    })
    .join('')
}

export const encodeEmoji = emoji => {
  if (!emoji) return ''

  return [...emoji]
    .map(char => {
      try {
        const codePoint = char.codePointAt(0)

        if (codePoint === undefined) {
          console.error(`Failed to get code point for character`)
          return ''
        }

        return `U+${codePoint.toString(16).toUpperCase()}`
      } catch (error) {
        console.error(`Failed to encode character:`, error)
        return ''
      }
    })
    .filter(code => code !== '')
    .join(' ')
}
